import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  ATS_DESCRIPCION_DETALLES,
  ATS_EQUIPOS_ELEMENTOS_CONDICIONES,
  EstadosOrdenTrabajoEnumChoice,
  gridSizeMdLg12,
  gridSizeMdLg4,
  gridSizeMdLg6,
  ROUTER_PATHS,
} from "@/shared";
import {
  // useFetchFlotas,
  useGetOrdenTrabajo,
  useUpdateATS,
  useUpdateFlota,
} from "@/shared/actions/erp";
import {
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  SampleCheckbox,
  SampleCheckboxNoForm,
  SingleFormBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import {
  AlertSeverityEnum,
  ATS,
  ATSExtended,
  // Flota,
} from "@/shared/interfaces";
import { atsFormSchema, hasPermission } from "@/shared/utils";
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from "@mui/material";
import { useUiConfirmModalStore, useUiStore } from "@/store/ui";
import { PermissionsEnum } from "@/auth/interfaces";
// import { useAuthStore } from "@/store/auth";
// import { EquiposUtilizadosOTTableType } from "./equipos";

export interface SaveATSProps {
  title: string;
  atsdata: ATSExtended;
  // isPlantaExternaUser?: boolean;
}

const SaveATS: React.FC<
  SaveATSProps
> = ({ title, atsdata }) => {
  const navigate = useNavigate();
  const returnURLATS = ROUTER_PATHS.tecnico.atsNav;

  // La OT puede estar en distintos estados (EN_ESPERA, ESPERA_RECOORDINADA,
  // ESPERA_ACTUALIZAR), y cada uno tiene una pantalla de detalle distinta.
  // Sin esto, al guardar el ATS siempre redirigia a /asignadas/<id> que solo
  // valida EN_ESPERA y disparaba el alert "no tiene el estado correcto"
  // cuando la OT venia de un flujo de recoordinacion.
  const { data: otRes } = useGetOrdenTrabajo(atsdata?.id_orden_trabajo || "");
  const otEstado = otRes?.data?.estado_orden_trabajo;
  const irAOT = () => {
    if (!atsdata?.id_orden_trabajo) return;
    const baseNav = ROUTER_PATHS.tecnico.ordenenTrabajoNav;
    let path = `${baseNav}/asignadas`;
    if (otEstado === EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA) {
      path = `${baseNav}/asignadas/recoordinada`;
    } else if (otEstado === EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR) {
      path = `${baseNav}/asignadas/pendientes-actualizar`;
    }
    navigate(`${path}/${atsdata.id_orden_trabajo}`);
  };
  // const userData = useAuthStore.getState().user;
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  const setAlert = useUiStore(s=>s.setAlert)
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [expanded, setExpanded] = useState<number | null>(0);

  const handleChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    console.log(event)
    setExpanded(isExpanded ? panel : null);
  };


  ///* form -----------------------
  // PERF: useForm<ATSExtended> (ATS & {..._data anidados}) hacía explotar Path<T> y el tsc.
  // Se usa un tipo plano para el form; el runtime no cambia (atsdata sigue tipado como ATSExtended).
  const form = useForm<Record<string, any>>({
    resolver: yupResolver(atsFormSchema) as any,
    defaultValues: {
      estado: true,
      area_create: "TÉCNICOS HOME",
      actividad: "TENDIDO DE FIBRA ÓPTICA ADSS/DROP DE INSTALACIÓN DE CLIENTES",
      herramientas: "ESCALERAS, TENSORES, HERRAJES, CONOS DE SEGURIDAD, HERRAMIENTA MENOR, FUSIONADORA, OTDR, POWER MATER, FIBRA ÓPTICA.",
      equipo_trabajo: `${atsdata?.flota_data?.nombre}\n ${atsdata?.flota_data?.auxiliar}`,
    },
  });

  const {
    formState: { errors },
  } = form;

  ///* mutations -----------------------
  const {
    mutateAsync:UpdateAsyncATS,
  } = useUpdateATS<Partial<ATS>>({
    enableAlert: false
  })

  const {
    mutateAsync: updateFlota
  } = useUpdateFlota({enableRedirect:false})
  ///* handlers ============================================
  const onSave = async (data: any) => {
    console.log({ATSExtended: data})
    // if(!atsdata.completado){
      UpdateAsyncATS({
        id:atsdata.id_analisis_trabajo_seguro!,
        data:{
          ...data,
          completado: true,
        }
      }, {
        // onSuccess:()=>{
        //   setAlert(true,"ATS guardado", AlertSeverityEnum.success)
        // },
        onError:()=>{
          setAlert(true,"Error al guardar ATS", AlertSeverityEnum.error)
        }
      })
    // }else{
    //   return navigate(returnURLATS)
    // }
  };

  const SolicitarLlenadoFisico = () => {
    UpdateAsyncATS({
      id:atsdata.id_analisis_trabajo_seguro!,
      data:{
        completado: true,
        solicita_formato_fisico: true
      }
    }, {
      onError:()=>{
        setAlert(true,"Error al guardar ATS", AlertSeverityEnum.error)
      }
    })
    setConfirmDialog({
      isOpen: true,
      title: "ATS Guardado Correctamente",
      subtitle:
        "El registro de Análisis de Trabajo Seguro se guardó correctamente. ¿Desea abrir la orden de trabajo correspondiente al ATS completado?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false)
        irAOT()
      },
      onClose: () => {
        setConfirmDialogIsOpen(false)
        navigate(returnURLATS)
      },
      confirmTextBtn: "SI",
      cancelTextBtn: "NO",
    })
  }
  const AprobarLlenadoFisico = () => {
    const auxCurrentFlota = atsdata?.flota_data
    updateFlota({
      id: auxCurrentFlota?.id_flota!,
      data:{
        ats_fisico_permitido: (auxCurrentFlota?.ats_fisico_permitido||0)>0?(auxCurrentFlota?.ats_fisico_permitido||1)-1:0
      }
    })
    UpdateAsyncATS({
      id:atsdata.id_analisis_trabajo_seguro!,
      data:{
        aprueba_formato_fisico: true,
        fecha_aprobacion: new Date(),
      }
    }, {
      onSuccess:()=>{
        setAlert(true,"Llenado Físico Aprobado", AlertSeverityEnum.success)
      },
      onError:()=>{
        setAlert(true,"Error al aprobar ATS", AlertSeverityEnum.error)
      }
    })
  }

  

  

  ///* effects -----------------------
  useEffect(() => {
    if (!atsdata?.id_analisis_trabajo_seguro) return;

    if(atsdata.completado){
      form.reset(atsdata)

    }else{
      // alert("hola")
      const medidasDeControl = ATS_DESCRIPCION_DETALLES.map(X=>X.medidas_de_control)
      atsdata.descripciones = medidasDeControl
      atsdata.equipos_proteccion_personal = ATS_EQUIPOS_ELEMENTOS_CONDICIONES.eec1_equipo_proteccion_personal
      atsdata.equipos_medicion_proteccion = ATS_EQUIPOS_ELEMENTOS_CONDICIONES.eec2_equipo_medicion_proteccion
      atsdata.equipos_complementarios = ATS_EQUIPOS_ELEMENTOS_CONDICIONES.eec3_equipo_complementario
      atsdata.procedimientos_especificos = ATS_EQUIPOS_ELEMENTOS_CONDICIONES.eec4_procedimiento_especifico
      form.reset(atsdata)
      // console.log({"qweqwe":form.getValues()})
    }

  }, [atsdata]);

  return (
    <>
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => {
        navigate(returnURLATS);
      }}
      onSave={async (_e)=>{
        onSave(form.getValues())
        setConfirmDialog({
          isOpen: true,
          title: "ATS Guardado Correctamente",
          subtitle:
            "El registro de Análisis de Trabajo Seguro se guardó correctamente. ¿Desea abrir la orden de trabajo correspondiente al ATS completado?",
          onConfirm: () => {
            setConfirmDialogIsOpen(false)
            irAOT()
          },
          onClose: () => {
            setConfirmDialogIsOpen(false)
            navigate(returnURLATS)
          },
          confirmTextBtn: "SI",
          cancelTextBtn: "NO",
        })
        }
      }
      num_referencia={atsdata?.codigo}
    >

      <Grid {...gridSizeMdLg12} container spacing={1} item justifyContent={"end"}>
        {
          !hasPermission(PermissionsEnum.api_aprobar_formato_fisico_ats) 
          && !atsdata.completado 
          && atsdata?.flota_data?.ats_fisico_permitido && atsdata?.flota_data?.ats_fisico_permitido > 0
          && <Grid item {...gridSizeMdLg4} textAlign={"right"}>
            <Button onClick={SolicitarLlenadoFisico} variant="contained">
              Solicitar formato físico
            </Button>
          </Grid>
        }
        {
          hasPermission(PermissionsEnum.api_aprobar_formato_fisico_ats) 
          && atsdata.completado
          && atsdata?.flota_data?.ats_fisico_permitido && atsdata?.flota_data?.ats_fisico_permitido > 0?
          <Grid item {...gridSizeMdLg4} textAlign={"right"}>
            <Button onClick={AprobarLlenadoFisico} variant="contained" color="success">
              Aprobar formato físico
            </Button>
          </Grid>
          :null
        }
      </Grid>

      <Grid container item {...gridSizeMdLg12} spacing={2}>
        <CustomTextFieldNoForm
          label="Cliente"
          value={atsdata?.prospecto_data?.razon_social}
          size={gridSizeMdLg12}
          disabled
        />
        <CustomTextFieldNoForm
          label="Elaborado Por"
          value={atsdata?.flota_data?.nombre||"N/A"}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextFieldNoForm
          label="Área"
          value={"Técnicos Home"}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextFieldNoForm
          label="Dirección"
          value={atsdata?.agendamiento_data?.direccion||"N/A"}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextFieldNoForm
          label="Fecha"
          value={atsdata?.agendamiento_data?.fecha_instalacion||"N/A"}
          size={gridSizeMdLg6}
          disabled
        />
        <SampleCheckbox
          name="es_antena"
          label="Antena"
          control={form.control}
          defaultValue={form.getValues()?.es_antena}
          size={gridSizeMdLg6}
        />
        <SampleCheckbox
          name="es_fibra"
          label="Fibra"
          control={form.control}
          defaultValue={form.getValues()?.es_fibra}
          size={gridSizeMdLg6}
        />
      </Grid>

      <Grid container item {...gridSizeMdLg12}>
        <CustomTextField
          label="Trabajo / Actividad"
          defaultValue={form.getValues()?.actividad}
          shrink={true}
          control={form.control}
          name="actividad"
          error={errors?.actividad?.message as any}
          helperText={errors?.actividad?.message?.toString()}
          disabled
        />
      </Grid>
      <Grid container item {...gridSizeMdLg12}>
        <CustomTextArea
          label="Herramientas y Equipos"
          defaultValue={form.getValues()?.herramientas}
          shrink={true}
          control={form.control}
          name="herramientas"
          error={errors?.herramientas?.message as any}
          helperText={errors?.herramientas?.message?.toString()}
          disabled
        />
      </Grid>
      <Grid container item {...gridSizeMdLg12}>
        <CustomTextArea
          label="Equipo de Trabajo"
          defaultValue={form.getValues()?.equipo_trabajo}
          shrink={true}
          control={form.control}
          name="equipo_trabajo"
          error={errors?.equipo_trabajo?.message as any}
          helperText={errors?.equipo_trabajo?.message?.toString()}
          disabled
        />
      </Grid>


      

      <Grid {...gridSizeMdLg12} container item spacing={2}>
        
        <Typography variant="h6" paddingY={2}>
          DESCRIPCIÓN DE LOS PASOS DE LA TAREA
        </Typography>
        {
          ATS_DESCRIPCION_DETALLES.map((item, index)=>
            <Accordion
              key={`seccion-pasos-area-${index}`}
              expanded={expanded === index}
              onChange={handleChange(index)}
              sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray"}}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{backgroundColor:"whitesmoke"}}
              >
                <TabTextLabel color="black" text={`${index+1}. ${item.descripcion_pasos_de_tarea}`} mt={0} pb={0} pl={0} pt={0} />
              </AccordionSummary>
              <AccordionDetails sx={{backgroundColor:"white", }}>
                <Grid container item {...gridSizeMdLg12} padding={3} sx={{border:2, borderColor:"whitesmoke"}} ref={(el) => (sectionRefs.current[index] = el)}>
                    <Typography fontWeight={"800"}>RIESGOS EN SEGURIDAD Y SALUD (Asociados a cada paso)</Typography>
                    {item.riesgos_seguridad_salud?.map((item)=>(
                      <>
                        <Typography sx={{py:.5}}>
                          - {item}
                          <hr/>
                        </Typography>
                      </>
                  ))}
                </Grid>
                <Grid container item {...gridSizeMdLg12}>
                  <Grid item {...gridSizeMdLg12}>
                    {form.getValues().descripciones?.[index]?.map((item:any, indexMCCheck:number)=>(
                      <>
                        <SampleCheckboxNoForm key={`medidas-control-item-${index}-${indexMCCheck}`}
                          label={item[0] as string}
                          // control={form.control}
                          // name={item[index][0] as string}
                          defaultValue={item[1] as boolean || false}
                          size={gridSizeMdLg12}
                          sizeCheck="medium"
                          onChangeValue={check=>{
                            const auxDescripciones =  [...form.getValues()?.descripciones]
                            auxDescripciones[index][indexMCCheck][1]=check
                            form.reset({...form.getValues(),
                              descripciones:auxDescripciones
                            })
                          }}
                          cssLabel={{ color: "black", fontSize:"16px", padding:"10px 0px" }}
                        />
                        <hr/>
                      </>)
                    )}
                    <Grid container item {...gridSizeMdLg12} spacing={2} padding={1}>
                      <Grid container item {...gridSizeMdLg6}>
                        <Button fullWidth variant="contained" color="secondary" onClick={()=>{
                          setExpanded(index?(()=>{
                            sectionRefs.current[index-1]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            return index-1
                          })():0)
                        }} disabled={index==0}>Anterior</Button>
                      </Grid>
                      <Grid container item {...gridSizeMdLg6}>
                        <Button fullWidth variant="contained" color="secondary" onClick={()=>{
                          setExpanded(index<ATS_DESCRIPCION_DETALLES.length?(()=>{
                            sectionRefs.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'start',});
                            return index+1
                          }):0)
                        }} disabled={index+1==ATS_DESCRIPCION_DETALLES.length}>Siguiente</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          )
        }
      </Grid>



      <Grid {...gridSizeMdLg12} container item spacing={2}>
        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Typography variant="h6" paddingY={2}>
            EQUIPOS, ELEMENTOS Y CONDICIONES DE SEGURIDAD REQUERIDOS PARA ESTA TAREA <br/>(Se recomienda utilizar &quot;Lista de Identificación de Riesgos&quot;)
          </Typography>
        </Grid>
        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Accordion
            key={`seccion-eec-${11}`}
            expanded={expanded === 11}
            onChange={handleChange(11)}
            sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray"}}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{backgroundColor:"whitesmoke"}}
            >
              <TabTextLabel color="black" text={`${1}. Equipo de protección personal`} mt={0} pb={0} pl={0} pt={0} />
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor:"white", }}>
              <Grid container item {...gridSizeMdLg12}>
                  {form.getValues()?.equipos_proteccion_personal?.map((item:any, indexEECCheck:number)=>(
                    
                      <SampleCheckboxNoForm key={`eec1-item-${indexEECCheck}`}
                        label={item[0] as string}
                        // control={form.control}
                        // name={item[index][0] as string}
                        defaultValue={item[1] as boolean}
                        size={gridSizeMdLg6}
                        sizeCheck="medium"
                        onChangeValue={check=>{
                          const auxDescripciones =  [...form.getValues()?.equipos_proteccion_personal]
                          auxDescripciones[indexEECCheck][1]=check
                          form.reset({...form.getValues(),
                            equipos_proteccion_personal:auxDescripciones
                          })
                        }}
                        cssLabel={{ color: "black", fontSize:"16px", padding:"10px 0px",}}
                      />
                    )
                  )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>


        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Accordion
            key={`seccion-eec-${12}`}
            expanded={expanded === 12}
            onChange={handleChange(12)}
            sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray", width:"100%"}}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{backgroundColor:"whitesmoke"}}
            >
              <TabTextLabel color="black" text={`${2}. Equipo de medición y protección`} mt={0} pb={0} pl={0} pt={0} />
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor:"white", }}>
              <Grid container item {...gridSizeMdLg12} >
                {form.getValues()?.equipos_medicion_proteccion?.map((item:any, indexEECCheck:number)=>(
                  <>
                    <SampleCheckboxNoForm key={`eec2-item-${indexEECCheck}`}
                      label={item[0] as string}
                      // control={form.control}
                      // name={item[index][0] as string}
                      defaultValue={item[1] as boolean}
                      size={gridSizeMdLg6}
                      sizeCheck="medium"
                      onChangeValue={check=>{
                        const auxDescripciones =  [...form.getValues()?.equipos_medicion_proteccion]
                        auxDescripciones[indexEECCheck][1]=check
                        console.log({auxDescripciones})
                        form.reset({...form.getValues(),
                          equipos_medicion_proteccion:auxDescripciones
                        })
                      }}
                      cssLabel={{ color: "black", fontSize:"16px", padding:"10px 0px" }}
                    />
                  </>)
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>

        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Accordion
            {...gridSizeMdLg12}
            key={`seccion-eec-${13}`}
            expanded={expanded === 13}
            onChange={handleChange(13)}
            sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray", width:"100%"}}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{backgroundColor:"whitesmoke"}}
              {...gridSizeMdLg12}
            >
              <TabTextLabel color="black" text={`${3}. Equipo complementario`} mt={0} pb={0} pl={0} pt={0} />
            </AccordionSummary>
            <AccordionDetails {...gridSizeMdLg12} sx={{backgroundColor:"white", }}>
              <Grid {...gridSizeMdLg12} container item>
                  {form.getValues()?.equipos_complementarios?.map((item:any, indexEECCheck:number)=>(
                    <>
                      <SampleCheckboxNoForm key={`eec3-item-${indexEECCheck}`}
                        label={item[0] as string}
                        // control={form.control}
                        // name={item[index][0] as string}
                        defaultValue={item[1] as boolean}
                        size={gridSizeMdLg6}
                        sizeCheck="medium"
                        onChangeValue={check=>{
                          const auxDescripciones =  [...form.getValues()?.equipos_complementarios]
                          auxDescripciones[indexEECCheck][1]=check
                          console.log({auxDescripciones})
                          form.reset({...form.getValues(),
                            equipos_complementarios:auxDescripciones
                          })
                        }}
                        cssLabel={{ color: "black", fontSize:"16px", padding:"10px 0px" }}
                      />
                    </>)
                  )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Accordion
            key={`seccion-eec-${14}`}
            expanded={expanded === 14}
            onChange={handleChange(14)}
            sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray", width:"100%"}}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{backgroundColor:"whitesmoke"}}
            >
              <TabTextLabel color="black" text={`${4}. Procedimiento específico`} mt={0} pb={0} pl={0} pt={0} />
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor:"white", }}>
              <Grid container item {...gridSizeMdLg12}>
                  {form.getValues()?.procedimientos_especificos?.map((item:any, indexEECCheck:number)=>(
                    <>
                      <SampleCheckboxNoForm key={`eec2-item-${indexEECCheck}`}
                        label={item[0] as string}
                        // control={form.control}
                        // name={item[index][0] as string}
                        defaultValue={item[1] as boolean}
                        size={gridSizeMdLg6}
                        sizeCheck="medium"
                        onChangeValue={check=>{
                          const auxDescripciones =  [...form.getValues()?.procedimientos_especificos]
                          auxDescripciones[indexEECCheck][1]=check
                          console.log({auxDescripciones})
                          form.reset({...form.getValues(),
                            procedimientos_especificos:auxDescripciones
                          })
                        }}
                        cssLabel={{ color: "black", fontSize:"16px", padding:"10px 0px" }}
                      />
                    </>)
                  )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>

        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Accordion
            key={`seccion-eec-${15}`}
            expanded={expanded === 15}
            onChange={handleChange(15)}
            sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray", width:"100%"}}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{backgroundColor:"whitesmoke"}}
            >
              <TabTextLabel color="black" text={`${5}. Otros`} mt={0} pb={0} pl={0} pt={0} />
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor:"white", }}>
              <Grid container item {...gridSizeMdLg12}>
                  <CustomTextArea
                    label="Otros materiales o equipos usados"
                    name="otros"
                    control={form.control}
                    size={gridSizeMdLg12}
                    error={errors.otros as any}
                    helperText={errors.otros?.message as any}
                  />
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>


      </Grid>

    </SingleFormBoxScene>
    </>
   
  );
};

export default SaveATS;
